import { Component } from '@angular/core';

@Component({
  selector: 'app-branding',
  template: `
  <a class="matero-branding" href="#/">
  <i>
  <svg version="1.1" width="24px" height="24px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 160 160" style="enable-background:new 0 0 160 160;" xml:space="preserve">
<style type="text/css">
	.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#8A181A;}
</style>
<path class="st0" d="M158.5,119.8l-79,34.4L1,119.8V40.6L79.5,6.8l79,33.8V119.8z M81.3,118.8c20.1,0,34.5-9.5,36.6-28H99.8
	c-1.5,9.6-8.5,14.3-18.7,14.3c-13.5,0-21.2-9-21.2-24.5v-0.8c0-15.5,8.2-24.7,21.1-24.7c10.2,0,15.7,4.8,17.1,13.8H117
	c-1.9-18.4-16.5-27.2-36.1-27.2c-23.1,0-40.5,15.5-40.5,38.2v0.8C40.4,103.8,54.7,118.8,81.3,118.8z"/>
</svg>
  </i>
  CAMS</a>
  `,
})
export class BrandingComponent {}
